import { Box, Grid, Typography } from "@mui/material";
import Block from "@/components/Block";
import { useCampground } from "@/contexts/AppConfigContext";
import { useBookingContext } from "@/contexts/BookingContext";

const CAMPSITE_TYPE_ICONS: Record<string, string> = {
  tent: "/images/tent.png",
  camper: "/images/motorhome.png",
  motorhome: "/images/motorhome.png",
  caravan: "/images/caravan.png",
  van: "/images/motorhome.png",
  accommodation: "/images/rental.png",
};

export default function Accommodation() {
  const { state, actions } = useBookingContext();
  const { data: campgroundData } = useCampground();
  const campsiteTypes = campgroundData.campsite_types;

  return (
    <Grid container spacing={{ xs: 1, md: 2 }} sx={{ mx: { xs: 2, md: 3 }, mb: { xs: 2, md: 3 } }}>
      {campsiteTypes.map(([value, label]) => {
        const selected = state.selectedCampsiteType === value;
        return (
          <Grid key={value} size={{ xs: 6, md: 4 }}>
            <Block
              onClick={() => actions.setSelectedCampsiteType(value)}
              sx={{
                height: { xs: 110, md: 150 },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
                p: { xs: 1, md: 3 },
                textAlign: "center",
                cursor: "pointer",
                borderColor: selected ? "primary.main" : "divider",
                bgcolor: selected ? "background.default" : "background.paper",
                "&:hover": {
                  borderColor: selected ? "primary.main" : "primary.light",
                  bgcolor: selected ? "background.default" : "action.hover",
                },
              }}
            >
              <Box
                component="img"
                src={CAMPSITE_TYPE_ICONS[value]}
                alt={label}
                sx={{
                  height: { xs: 40, md: 60 },
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
              />
              <Typography variant="body1" textTransform="capitalize" fontWeight={600}>
                {label}
              </Typography>
            </Block>
          </Grid>
        );
      })}
    </Grid>
  );
}
